module.exports = __webpack_public_path__ + "img/programming_languages_lowHighCompInterp.41e11926.png";